{
  "title": "Season calendar",
  "loading": "Loading the season",
  "error": "We couldn't load the season. Try again.",
  "retry": "Try again",
  "empty_title": "The next season is on its way",
  "empty": "Its dates aren't out yet, so keep your golfer training until they are.",
  "offline": "The season calendar needs a connection the first time you open it. Try again when you're back online.",
  "season_name": "{series, select, preview {Preview season {no}} other {Season {no}}}",
  "banner": "{season} · Week {week} of 13 · {days, plural, one {# day left} other {# days left}}",
  "position": "Week {week} of 13 · {days, plural, one {# day left} other {# days left}}",
  "banner_label": "{season}, week {week} of 13, {days, plural, one {# day left} other {# days left}}. Open the season calendar.",
  "starts_on": "{season} starts on {date}",
  "provisional": "Dates may still move",
  "strip_label": "The 13 weeks of {season}",
  "turn": "The Turn",
  "rest": "Nothing counts this week",
  "key_major": "Major week",
  "key_rest": "Break Week: nothing counts",
  "week": "Week {week}",
  "week_dates": "{from} to {to}",
  "today": "This week",
  "break_week": "Break Week",
  "nothing": "Nothing on the calendar this week.",
  "this_week": "This week",
  "next_week": "Next week",
  "next_season": "Next: {season}",
  "next_season_starts": "Starts on {date}",
  "week_label": "Week {week}{when, select, past {, done} today {, this week} other {}}. {items}",
  "week_label_rest": "Week 13, the Break Week. Nothing counts this week. {items}",
  "week_label_empty": "Nothing on the calendar.",
  "days": {
    "one": "{day}",
    "range": "{from} to {to}",
    "all_week": "All week"
  },
  "item": {
    "major_1": "The White Rose Invitational",
    "major_2": "The Guild Championship",
    "major_3": "The Atlantic Open",
    "major_4": "The Links Championship",
    "major_line": "{name} ({gender, select, men {men's} other {women's}})",
    "regular": "{gender, select, men {Atlantic Tour event} other {Atlantic Women's Tour event}}",
    "warmup": "{gender, select, men {Atlantic Tour warm-up} other {Atlantic Women's Tour warm-up}}",
    "finale": "Race to the Finale: the {gender, select, men {men's} other {women's}} finale",
    "tour_school": "{stage, select, final {Tour School final} other {Tour School, stage {stage}}}",
    "cup_pro_odd": "The Lantern Cup",
    "cup_pro_even": "The Anchor Cup",
    "cup_am_odd": "The Crossing Cup",
    "cup_am_even": "The Voyage Cup",
    "turn_day": "The Turn",
    "equipment_reveal": "New kit revealed",
    "equipment_release": "New kit released",
    "awards_night": "Season awards",
    "big_open": "Big weekend open",
    "derby_week": "Derby week",
    "club_championship": "Club championship",
    "presentation": "Presentation night",
    "real_major_week": "Big week in golf"
  },
  "item_label": "{name}, {days}"
}
